import { Route, Routes, useNavigate } from "react-router";
import Plano from "./plano";
import Espacios from "./espacios";
import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from "react";
import ReservaUbicacionDialog from "../components/reservarOcupacion";

export default function Main({ usuario, espacios }) {
  let navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [conBack, setConBack] = useState(false);

  const [espacio, setEspacio] = useState(null);
  const [ubicacion, setUbicacion] = useState(null);
  const [visitante, setVisitante] = useState(null);
  const [reservaOpen, setReservaOpen] = useState(false);

  const changeTitle = (newTitle) => {
    setTitle(newTitle);
  }

  const changeConBack = (llevaBack) => {
    setConBack(llevaBack);
  }

  const handleSelectSpace = (selectedId) => {
    console.log('handleSelectSpace(' + selectedId + ')');
    setEspacio(espacios.find(item => item.id == selectedId));
    // redirect('/plano:' + selectedId);
    navigate('/plano/' + selectedId);
  }

  const handleSelectedSlots = (selectedIds) => {
    console.log('handleSelectedSlots' + JSON.stringify(selectedIds));
    setUbicacion(espacio.slots.find(slot => slot.id == selectedIds[0] ?? null));
  }

  const handleReservaConfirm = () => {

  }

  const handleReservaDialogClose = () => {
    setReservaOpen(false);
    setUbicacion(null);
  }

  const handleBack = () => {
    navigate(-1);
  }

  useEffect(() => {
    if (window.sistema) {
      window.sistema.espacio = espacio
     };
    if (!espacio && window.location.pathname.includes('plano')) {
      navigate('/');
    }
  }, [espacio]);

  useEffect(() => {
    if (window.sistema) {
      window.sistema.ubicacion = ubicacion;
     };
    if (!!ubicacion) {
      setVisitante(ubicacion.visitante ?? null);
      setReservaOpen(true);
    }
  }, [ubicacion]);

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Typography variant="h6">{title}</Typography>
          <Stack direction="row">
            {!!conBack ?
              <IconButton aria-label="logout" onClick={handleBack}>
                <ArrowBack />
              </IconButton>
              : !!usuario &&
              <IconButton aria-label="logout">
                <Logout />
              </IconButton>
            }
          </Stack>
        </Toolbar>
      </AppBar>
      <ReservaUbicacionDialog open={reservaOpen} title={!!visitante ? 'Devolución de carrito' : 'Ingreso de carrito'} slotId={ubicacion?.id} slotLabel={ubicacion?.label} visitante={visitante} editable={!visitante} onCancel={handleReservaDialogClose} onConfirm={handleReservaConfirm} />
      <Routes>
        <Route index element={<Espacios espacios={espacios} changeConBack={changeConBack} changeTitle={changeTitle} onSelectSpace={handleSelectSpace}></Espacios>}></Route>
        <Route path='/plano/:id' element={<Plano espacio={espacio} selected={[ubicacion?.id]} changeConBack={changeConBack} changeTitle={changeTitle} onChangeSelected={handleSelectedSlots}></Plano>}></Route>
      </Routes>
    </Box>
    );

  }
